import { TenantType } from './types';
import { getTenant } from './storageUtils';

export interface TenantConfig {
  showDashboardImmediately: boolean;
}

const DEFAULT_CONFIG: TenantConfig = {
  showDashboardImmediately: false,
};

const TENANT_CONFIGS: Record<string, Partial<TenantConfig>> = {
  [TenantType.PB as string]: { showDashboardImmediately: false },
  [TenantType.YESBANK as string]: { showDashboardImmediately: true },
  [TenantType.MAHINDRA as string]: { showDashboardImmediately: false },
  [TenantType.JFS as string]: { showDashboardImmediately: false },
  [TenantType.AU as string]: { showDashboardImmediately: true },
};

export function getTenantConfig(): TenantConfig {
  const currentTenant = getTenant();
  if (!currentTenant) return DEFAULT_CONFIG;
  return { ...DEFAULT_CONFIG, ...(TENANT_CONFIGS[currentTenant] || {}) };
}

export function getInitialRenderingCompletedValue(): boolean {
  return getTenantConfig().showDashboardImmediately;
}
